// Modules
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NGXBootstrapModule } from './ngx-bootstrap.module';
import { GridsterModule } from 'angular-gridster2';
import { DGSCoreModule } from '@dotgov/core';
import { DataGridModule } from '@dotgov/datagrid';

// Services
import { ToastrService } from 'ngx-toastr';

// Components
import { RendererComponent } from './components/renderer/renderer.component';
import { GridComponent } from './components/widgets/grid/grid.component';
import { ListComponent } from './components/widgets/list/list.component';
import { WidgetConfiguratorComponent } from './components/widgets/widget-configurator/widget-configurator.component';
import { DynamicRendererComponent } from './components/dinamic-renderer/dynamic-renderer.component';
import { WidgetPreviewComponent } from './components/widgets/preview/preview.component';
import { PlainHtmlComponent } from './components/widgets/plain-html/plain-html.component';

// Pipes
import { SafePipe } from './pipes/safe.pipe';

// Utils
import { Widgets } from './models/widgets';

const components = [
  RendererComponent,
  GridComponent,
  ListComponent,
  WidgetConfiguratorComponent,
  WidgetPreviewComponent,
  PlainHtmlComponent,
  ...Widgets,
];

@NgModule({
  declarations: [
    ...components,
    DynamicRendererComponent,
    SafePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridsterModule,
    NGXBootstrapModule,
    DGSCoreModule,
    DataGridModule,
  ],
  providers: [
    ToastrService,
  ],
  exports: [
    ...components,
  ],
  entryComponents: [
    ...Widgets,
  ],
})
export class InterfaceBuilderModule {
  public static forRoot(_environment): ModuleWithProviders {
    return {
      ngModule: InterfaceBuilderModule,
      providers: [
        NGXBootstrapModule.forRoot().providers,
        DataGridModule.forRoot(_environment).providers,
        { provide: 'enviroment', useValue: _environment },
      ],
    };
  }
}
